module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"file_selection":"File selection","csv_coercion":"CSV coercion","csv_format":"CSV format","hexa_preview":"Hexadecimal preview"},"fr":{"file_selection":"Sélection du fichier","csv_coercion":"Coercion du CSV","csv_format":"Format du CSV","hexa_preview":"Aperçu hexadécimal"}}')
  delete Component.options._Ctor
}
